import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const isInIframe = () => {
  try {
    return window !== window.parent;
  } catch (e) {
    return true; 
  }
};

// Add special class to body if in iframe
if (isInIframe()) {
  document.body.classList.add('in-iframe');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();